// extracted by mini-css-extract-plugin
export default {"questionItem_li":"QuestionItem_questionItem_li__F6qVd","questionItem_div":"QuestionItem_questionItem_div__vL9tU","questionItem_link":"QuestionItem_questionItem_link__AtQYJ"};